<template>
  <v-layout
    row
    wrap
    align-center
    class="text-xs-center grey--text text--darken-1"
    style="border: 1px solid #ccc; background: white;"
  >
    <v-flex>
      <h3>{{ inCurrencyFromId(displayedCurrencyId, customersBalance) }}</h3>
      Total Customers Balance
    </v-flex>
    <v-flex shrink>
      <v-layout row wrap>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-icon>add</v-icon>
        </v-flex>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex>
      <h3>{{ inCurrencyFromId(displayedCurrencyId, suppliersBalance) }}</h3>
      Total Suppliers Balance
    </v-flex>

    <v-flex shrink>
      <v-layout row wrap>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-icon>add</v-icon>
        </v-flex>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex>
      <h3>{{ inCurrencyFromId(displayedCurrencyId, inventory) }}</h3>
      Total Inventory
    </v-flex>

    <v-flex shrink>
      <v-layout row wrap>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-icon>add</v-icon>
        </v-flex>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
      </v-layout>
    </v-flex>


    <v-flex>
      <h3>{{ inCurrencyFromId(displayedCurrencyId, bankAmount) }}</h3>
      Total in Bank Accounts
    </v-flex>

    <v-flex shrink>
      <v-layout row wrap>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-icon>mdi-equal</v-icon>
        </v-flex>
        <v-flex xs12>
          <v-divider vertical></v-divider>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex>
      <h3>{{ inCurrencyFromId(displayedCurrencyId, equity) }}</h3>
      Total Equity
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency";
import accountingFilters from "../../../mixins/accountingFilters";
import COMPANY_BALANCES from "../../../graphql/company_balances/index.gql"
import EQUITY from "../../../graphql/accounting/equity.gql"
import axios from "axios";

export default {
  name: "equity",
  mixins: [currency, accountingFilters],
  data() {
    return {
      customersBalance: 0,
      suppliersBalance: 0,
      bankAmount: 0,
      inventory: 0,
      equity: 0,
      displayedCurrencyId: this.currencyId || this.exchangeRatesBaseCurrencyID
    };
  },
  props: {
    exchangeRatesBaseCurrencyID: String
  },
  computed: {
    ...mapGetters("commonStore", ["bankInformations", "subsidiaries"])
  },
  methods: {
    fetchEquity() {
      this.sendQuery(EQUITY, { currencyId: this.displayedCurrencyId, subsidiaryId: this.subsidiaryId}).then(data => {
        console.log(data)
        this.customersBalance = data.equity.total_customers_balance
        this.suppliersBalance = data.equity.total_suppliers_balance
        this.bankAmount = data.equity.total_in_bank_accounts
        this.inventory = data.equity.total_inventory
        this.equity = data.equity.total_equity
      })
    },
  },
  mounted() {
    this.fetchEquity()
  },
  watch: {
    exchangeRatesBaseCurrencyID() {
      this.displayedCurrencyId = this.currencyId || this.exchangeRatesBaseCurrencyID
      this.fetchEquity()
    },
    currencyId() {
      this.displayedCurrencyId = this.currencyId || this.exchangeRatesBaseCurrencyID
      this.fetchEquity()
    },
    subsidiaryId() {
      this.displayedCurrencyId = this.currencyId || this.exchangeRatesBaseCurrencyID
      this.fetchEquity()
    },
  },
};
</script>
